(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasFinePointer = window.matchMedia('(any-pointer: fine)').matches;

  function initScrollReveal() {
    var targets = document.querySelectorAll('.hero-wrapper, .slideshow-section, .section-wrapper');
    if (!targets.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('niyara-in-view');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      el.classList.add('niyara-reveal');
      io.observe(el);
    });
  }

  function initHeroParallax() {
    var zones = document.querySelectorAll('.hero__container, .slideshow-section slideshow-slide');
    if (!zones.length) return;

    zones.forEach(function (zone) {
      var media = zone.querySelector('.hero__media, img, video');
      if (!media) return;

      var raf = null;

      function onMove(e) {
        var rect = zone.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;

        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          media.style.transform =
            'scale(1.08) translate3d(' + (x * -16) + 'px, ' + (y * -16) + 'px, 0)';
        });
      }

      function onLeave() {
        if (raf) cancelAnimationFrame(raf);
        media.style.transform = '';
      }

      zone.addEventListener('mousemove', onMove);
      zone.addEventListener('mouseleave', onLeave);
    });
  }

  function init() {
    if (!reduceMotion) initScrollReveal();
    if (!reduceMotion && hasFinePointer) initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
